import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import CardTitle from "@saleor/components/CardTitle";
import Hr from "@saleor/components/Hr";
import ImageTile from "@saleor/components/ImageTile";
import ImageUpload from "@saleor/components/ImageUpload";
import Skeleton from "@saleor/components/Skeleton";
import useNotifier from "@saleor/hooks/useNotifier";
import { commonMessages } from "@saleor/intl";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { SellerDetails_brandPrivate_logo } from "../../types/SellerDetails";

const useStyles = makeStyles(
  theme => ({
    PhotosIcon: {
      height: "64px",
      margin: "0 auto",
      width: "64px"
    },
    PhotosIconContainer: {
      margin: theme.spacing(5, 0),
      textAlign: "center"
    },
    fileField: {
      display: "none"
    },
    image: {
      height: "100%",
      objectFit: "contain",
      userSelect: "none",
      width: "100%"
    },
    imageContainer: {
      background: "#ffffff",
      border: "1px solid #eaeaea",
      borderRadius: theme.spacing(),
      height: 148,
      justifySelf: "start",
      overflow: "hidden",
      padding: theme.spacing(2),
      position: "relative",
      width: 148
    }
  }),
  {
    name: "SellerLogo"
  }
);

const fileSizeLimit = 2.5e6;

export interface SellerLogoProps {
  data: {
    logoAlt: string;
  };
  image: SellerDetails_brandPrivate_logo;
  onChange: (event: React.ChangeEvent<any>) => void;
  onImageDelete: () => void;
  onImageUpload: (file: File) => void;
  onFileSizeError: () => void;
}

export const SellerLogo: React.FC<SellerLogoProps> = props => {
  const {
    data,
    onImageUpload,
    image,
    onChange,
    onImageDelete,
    onFileSizeError
  } = props;

  const anchor = React.useRef<HTMLInputElement>();
  const classes = useStyles(props);
  const intl = useIntl();
  const notify = useNotifier();
  const hideDescription = true;
  const handleImageUploadButtonClick = () => anchor.current.click();

  const checkImageSize = (file: File) => {
    if (file.size > fileSizeLimit) {
      onFileSizeError();
    } else {
      checkFile(file);
    }
  };

  const checkFile = e => {
    const file = e;

    if (
      file.type.includes("image/jpeg") ||
      file.type.includes("image/jpg") ||
      file.type.includes("image/png")
    ) {
      onImageUpload(e);
    } else {
      notify({
        status: "error",
        text: "File not supported"
      });
    }
  };

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Trademark Image ",
          description: "section header"
        })}
        toolbar={
          <>
            <Button
              id="uploadImageBtn"
              variant="text"
              color="primary"
              onClick={handleImageUploadButtonClick}
            >
              <FormattedMessage {...commonMessages.uploadImage} />
            </Button>
            <input
              className={classes.fileField}
              id="fileUpload"
              onChange={event => checkImageSize(event.target.files[0])}
              type="file"
              ref={anchor}
              accept="image/jpg, image/jpeg, image/png"
            />
          </>
        }
      />
      {image === undefined ? (
        <CardContent>
          <div>
            <div className={classes.imageContainer}>
              <Skeleton />
            </div>
          </div>
        </CardContent>
      ) : image === null ? (
        // <ImageUpload onImageUpload={files => onImageUpload(files[0])} />

        <ImageUpload onImageUpload={files => checkImageSize(files[0])} />
      ) : (
        <CardContent>
          <ImageTile image={image} onImageDelete={onImageDelete} />
        </CardContent>
      )}
      {!hideDescription && image && (
        <>
          <Hr />
          <CardContent>
            <TextField
              name="logoAlt"
              label={intl.formatMessage(commonMessages.description)}
              helperText={intl.formatMessage({
                defaultMessage: "(Optional)",
                description: "field is optional"
              })}
              value={data.logoAlt}
              onChange={onChange}
              fullWidth
              multiline
            />
          </CardContent>
        </>
      )}
    </Card>
  );
};

SellerLogo.displayName = "SellerLogo";
export default SellerLogo;
